import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ListItem } from 'src/app/shared/models/list-item.model';

@Component({
    selector: 'nova-offer-reason-dialog',
    templateUrl: './offer-reason-dialog.component.html',
    styleUrls: ['./offer-reason-dialog.component.scss']
})
export class OfferReasonDialogComponent {
    reasons: ListItem[];
    reasonResult: ListItem;
    reasonDesc = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { id: number; reasons: ListItem[] },
        private readonly dialogRef: MatDialogRef<OfferReasonDialogComponent>
    ) {}

    close() {
        this.dialogRef.close();
    }

    confirm() {
        const reasonText = this.isOtherReason() ? this.reasonDesc : this.reasonResult.name;
        const reason = { id: this.data.id, reasonId: this.reasonResult.id, reasonText: `Reason: ${reasonText}` };
        this.dialogRef.close(reason);
    }

    isOtherReason(): boolean {
        return this.reasonResult && this.reasonResult.name === 'Other';
    }
}
